import { trackPromise } from 'react-promise-tracker'

import api from 'utils/api'
import { ApiResponse } from 'utils/types'
import { DataTableRequest } from 'components/data-table/types'

const url = '/v1/profile'
const Api = {
  get: (id: string): Promise<ApiResponse> => trackPromise<ApiResponse>(api.get(`${url}/${id}`)),
  list: (): Promise<ApiResponse> => trackPromise<ApiResponse>(api.get(`${url}`)),
  create: (request: any): Promise<ApiResponse> => trackPromise<ApiResponse>(api.post(url, request)),
  createPermission: (request: any): Promise<ApiResponse> => trackPromise<ApiResponse>(api.post(`${url}/permission`, request)),
  search: (request: DataTableRequest): Promise<ApiResponse> => trackPromise<ApiResponse>(api.post(`${url}/search`, request)),
  update: (request: any): Promise<ApiResponse> => trackPromise<ApiResponse>(api.put(url, request)),
  delete: (id: string): Promise<ApiResponse> => trackPromise<ApiResponse>(api.delete(`${url}/${id}`)),
  deletePermission: (profileId: string, id: string): Promise<ApiResponse> => trackPromise<ApiResponse>(api.delete(`${url}/${profileId}/${id}`)),
}

export default Api
